import $ from "jquery";
window.jQuery = $;
import { Fancybox } from "@fancyapps/ui";

Fancybox.bind("[data-fancybox]", {
  Carousel: {
    Navigation: {
      prevTpl:
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 281.454 496.84"><path fill="#2b2e34" d="M265.597 0-.003 248.42l265.6 248.42 15.857-15.857L147.997 248.42 281.454 15.857Z" /></svg>',
      nextTpl:
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 466.51 823.514"><path d="M0 26.318 221.223 411.76 0 797.241l26.317 26.273L466.51 411.76 26.317 0Z" /></svg>',
    },
  },
});
